<template>
	<v-treeview
		:items="actions"
		:active.sync="selectedVehicle"
		item-disabled="locked"
		activatable
		multiple-active
		dense
		@update:active="activateVehicle"
	>
		<template v-slot:prepend="{item}">
			<v-icon v-if="enabledVehicle.has(item.id)">mdi-eye</v-icon>
			<v-icon v-else>mdi-eye-off</v-icon>
		</template>
		<template v-slot:append="{ item }">
			<v-icon>mdi-chevron-triple-right</v-icon>
			<v-spacer></v-spacer>
			<v-icon v-if="item.target.vehicle_name">mdi-car</v-icon>
			<v-icon v-else>mdi-folder</v-icon>
			{{item.target.vehicle_name ? item.target.vehicle_name : item.target.name}}
		</template>
	</v-treeview>
</template>

<script>
	import { Logger } from "aws-amplify";
	const logger = new Logger("Actions");

	export default {
		props: {
			actions: {
				required: true,
				type: Array
			},
			isHidden: {
				required: true,
				type: Boolean
			}
		},
		data: () => ({
			selectedVehicle: [],
			enabledVehicle: new Set()
		}),
		watch: {
			actions(val) {
				this.selectedVehicle = [];
				if (val) {
					if (!this.isHidden) {
						this.activateAll();
					}
				}
			}
		},
		mounted() {
			if (!this.isHidden) {
				this.activateAll();
			}
		},
		methods: {
			activateAll() {
				logger.debug("actions", this.actions, this.selectedVehicle);
				this.selectedVehicle = this.actions.map(v => v.id);
			},
			activateVehicle(val) {
				logger.debug("activateVehicle", val, this.selectedVehicle);
				this.$emit("update:active", this.enabledVehicle);
				this.enabledVehicle = new Set(this.selectedVehicle);
			}
		}
	};
</script>